export default __webpack_public_path__ + "static/media/NeueMontreal-Regular.140bfb4a.otf";